import { Bell, UserRound } from 'lucide-react'

export function HeaderActions() {
  return (
    <>
      <button
        type="button"
        className="flex h-9 w-9 items-center justify-center rounded-full border border-border bg-background-secondary text-sidebar-text transition-colors hover:text-foreground"
        aria-label="Notifications"
      >
        <Bell className="h-[18px] w-[18px]" aria-hidden="true" />
      </button>
      <button
        type="button"
        className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-primary-foreground"
        aria-label="Account"
      >
        <UserRound className="h-[18px] w-[18px]" aria-hidden="true" />
      </button>
    </>
  )
}
